import React from 'react';
import { Edit, DisabledInput } from 'react-admin';
import PriorizacionForm from '../PriorizacionForm';

function PriorizacionEdit(props) {
  return (
    <Edit undoable={false} {...props}>
      <PriorizacionForm redirect="list">
        <DisabledInput label="Id" source="id" />
      </PriorizacionForm>
    </Edit>
  );
}

export default PriorizacionEdit;
